enum Onex3534Group {
  PLAIN = 'PLAIN',
  DETAILED = 'DETAILED',
  DETAILED_ANIMATED_DEV = 'DETAILED_ANIMATED_DEV',
  STATUS_QUO = 'STATUS_QUO',
}

export default Onex3534Group;
